import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';

import { FirsTechClient } from '@/models';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private httpClient: HttpClient) {}

  public loadClientsForUser(): Observable<FirsTechClient[]> {
    return this.httpClient
      .get<FirsTechClient[]>(environment.serviceEndpoints.clients.toString())
      .pipe(
        catchError((err) => {
          console.log('ERROR', err);
          return [];
        }),
      );
  }

  public loadClients(...ids: number[]) {
    if (ids.length === 0) {
      return EMPTY;
    } else {
      const url = new URL(environment.serviceEndpoints.clients);
      ids.forEach((id) => url.searchParams.append('id', id.toString()));

      return this.httpClient.get<FirsTechClient[]>(url.toString()).pipe(
        catchError((err) => {
          console.error('ERROR', err);
          return [];
        }),
      );
    }
  }

  public loadClient(clientId: number): Observable<FirsTechClient> {
    return this.httpClient.get<FirsTechClient>(
      new URL(
        clientId.toString(),
        environment.serviceEndpoints.clients,
      ).toString(),
    );
  }
}
